import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/angi-thumbtack-alternatives-colorado")!;

export const Route = createFileRoute("/learn/angi-thumbtack-alternatives-colorado")({
  head: () => seoHead("/learn/angi-thumbtack-alternatives-colorado", "Angi & Thumbtack Alternatives for Colorado Contractors", "A fair guide to lead services plus free, owned alternatives for Colorado contractors: website, SEO, Google Maps, AI search, and social media.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
